import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=603383a0&"
import script from "./Login.vue?vue&type=script&lang=ts&"
export * from "./Login.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseInput: require('/home/vsts/work/1/a/NuxtApp/components/base/Input.vue').default,BaseFormItem: require('/home/vsts/work/1/a/NuxtApp/components/base/FormItem.vue').default,AppNoty: require('/home/vsts/work/1/a/NuxtApp/components/app/Noty.vue').default,BaseButton: require('/home/vsts/work/1/a/NuxtApp/components/base/Button.vue').default,BaseForm: require('/home/vsts/work/1/a/NuxtApp/components/base/Form.vue').default})
